// extracted by mini-css-extract-plugin
export default {"root":"Popover_root__Qs-rB","button":"Popover_button__VVEyW","dots":"Popover_dots__kOtRg"};